import {
  LOAD_REPORT_DATA,
  LOAD_REPORT_DATA_SUCCESS,
  LOAD_REPORT_DATA_FAILURE,
  CLEAR_REPORT_DATA,
  LOAD_IMAGING_DATA,
  LOAD_IMAGING_DATA_SUCCESS,
  LOAD_IMAGING_DATA_FAILURE,
  LOAD_SPECIES_RANKING,
  LOAD_SPECIES_RANKING_SUCCESS,
  LOAD_SPECIES_RANKING_FAILURE,
} from "../actions/types";

const DEFAULT_USER_SETTINGS = {
  report: {
    data: [],
    loading: false,
    error: null,
    // when the shown data came back from the server
    generatedAt: null,
    // the load the report is waiting on or showing; any other's answer is stale
    request: null,
  },
  monthlyData: {
    data: [],
    loading: false,
    error: null,
  },
  // whose ranking `labels` is, so switching organization reloads it
  speciesRanking: {
    organization: null,
    labels: [],
    loading: false,
  },
};

//eslint-disable-next-line
export default (state = DEFAULT_USER_SETTINGS, action) => {
  switch (action.type) {
    case LOAD_REPORT_DATA:
      return {
        ...state,
        report: { ...state.report, data: [], loading: true, generatedAt: null, request: action.request },
      };
    case LOAD_REPORT_DATA_SUCCESS:
      if (state.report.request !== action.request) return state;
      return {
        ...state,
        report: {
          ...state.report,
          loading: false,
          data: action.payload,
          generatedAt: action.generatedAt ?? null,
        },
      };
    case LOAD_REPORT_DATA_FAILURE:
      if (state.report.request !== action.request) return state;
      return {
        ...state,
        report: { ...state.report, loading: false, data: [], generatedAt: null },
      };
    case CLEAR_REPORT_DATA:
      return {
        ...state,
        report: { loading: false, data: [], error: null, generatedAt: null, request: null },
      };
    case LOAD_IMAGING_DATA:
      return {
        ...state,
        monthlyData: { ...state.monthlyData, data: [], loading: true },
      };
    case LOAD_IMAGING_DATA_SUCCESS:
      return {
        ...state,
        monthlyData: {
          ...state.monthlyData,
          loading: false,
          data: action.payload,
        },
      };
    case LOAD_IMAGING_DATA_FAILURE:
      return {
        ...state,
        monthlyData: { ...state.monthlyData, loading: false, data: [] },
      };
    case LOAD_SPECIES_RANKING:
      return {
        ...state,
        speciesRanking: { organization: action.payload.organization, labels: [], loading: true },
      };
    case LOAD_SPECIES_RANKING_SUCCESS:
    case LOAD_SPECIES_RANKING_FAILURE:
      if (state.speciesRanking?.organization !== action.payload.organization) {
        return state;
      }
      return {
        ...state,
        speciesRanking: {
          organization: action.payload.organization,
          labels: action.payload.labels ?? [],
          loading: false,
        },
      };
    default:
      return state;
  }
};
